<template lang="html">
  <v-container style="margin-top: 1em;">

  <h2>PRIVACY POLICY</h2><br><br>

Betadigitis is committed to maintaining your confidence and trust with respect to the privacy of the personal information we collect from you. <br><br>Please read this privacy policy carefully to understand our practices about how we collect, use and share your personal information.

<br><br><strong>About our Privacy Policy </strong><br>

This privacy policy describes how the personal information that is collected when you use the Betadigitis application will be used by BetaDigitis.

<br><br><strong>Information We Collect </strong><br>

The Service collects information from you in two ways: directly from your input and automatically through the Service's technologies.

<br><br><strong>Information You Provide</strong><br>

The types of personal information that the Service collects directly from you may include:
<ul>
 	<li>Contact details, such as your name, email address, postal address and telephone number;</li>
 	<li>Usernames and passwords.</li>
</ul>
<br>In order to access certain content and to make use of additional functionality and features of the Service, we ask you to register for an account by completing and submitting a registration form, which may request additional information.

<br><br>If you choose to register and sign in by using a third party account (such as your Facebook account), the authentication of your login is handled by the third party and the Service will collect your name, email address and any other information about your third-party account that you agree to share with us at the time you give permission for your account on the Service to be linked to your third party account.

<br><br><strong>Information Collected Automatically</strong><br>

The Service also automatically collects, through our applications and other technologies, information that tells us how you use the Service, such as:
<ul>
 	<li>Internet Protocol ("IP") address used to connect your computer to the Internet;</li>
 	<li>GPS localisation;</li>
 	<li>Device and connection information, such as browser type and version, operating system, mobile platform and unique device identifier ("UDID") and other technical identifiers;</li>
 	<li>Uniform Resource Locator ("URL") click stream data, including date and time stamp, referring and exit URLs, search terms you used, and pages you visited or searched for on the Service; and</li>
 	<li>For location-aware services, the physical location of your device in order to provide you with more relevant content for where you are in the world.</li>
</ul>
<br><br>We may use and disclose information that does not reveal your identity or permit direct association with any specific individual, such as browser and device information, anonymous usage data and aggregated information, for any purpose, except where we are restricted by law. If we combine non-personal information with personal information, the combined information will be treated as personal information for as long as it remains combined.

<br><br><strong>Use of Your Information</strong><br> We may use your personal information to:
<ul>
 	<li>Identify and analyze usage trends, including for the purposes of research, audits, reporting;</li>
 	<li>Notify you about changes or updates to the Service and our products and services.</li>
</ul>
<br><br><strong>Your Choices and Communications Preferences</strong><br>


You can manage your communications preferences when you register with the Service, by updating your account preferences, by using the "opt-out" or unsubscribe mechanism or other means provided within the communications that you receive from us or by contacting us. We reserve the right to notify you of changes or updates to the Service whenever necessary.

<br><br><strong>Access to and Accuracy of Your Information</strong><br>

The Service may allow registered users to access their account information and make corrections or updates upon log in at any time. The accuracy of such information is solely the responsibility of the user. You may also request access to other personal information about you that may be held in the Service. If you request to deactivate your account or delete your personal information, we will endeavor to fulfill your request but some personal information may persist in backup copies for a certain period of time and may be retained as necessary for legitimate business purposes or to comply with our legal obligations.

<br><br><strong>Data Security</strong><br>

Betadigitis takes precautions to safeguard your personal information against loss, theft and misuse and unauthorized access, disclosure, alteration and destruction through the use of appropriate administrative, physical and technical security measures.

<br><br><strong>Changes to Our Privacy Policy</strong><br>
We may change this privacy policy from time to time. Any changes will be posted on this page with an updated revision date.

<br><br><strong>Contact</strong><br>

If you have any questions, comments or requests regarding this privacy policy or our processing of your information, please contact: contact@betadigtis.com

<br><br>This privacy policy was last updated on 11 April 2019.

</v-container>
</template>

<script>
export default {
  data() {
    return {
      icons: [
        'fab fa-facebook',
        'fab fa-twitter',
        'fab fa-linkedin'
      ]
    }
  }
}
</script>

<style lang="css" scoped>
</style>
